import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonicwallComponent } from './simple-icons-sonicwall.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonicwallComponent ],
    exports:      [ SimpleIconsSonicwallComponent ],
    bootstrap:    []
})
export class SimpleIconsSonicwallModule {}
